module.exports = __webpack_public_path__ + "img/like-nobg.dd102d40.svg";